import React from 'react';
import {Avatar, ListItem, makeStyles} from '@rneui/themed';

import {RewardsInformationResponse} from '../../../transport/types';
import Text from '../../themed/Text';

type BenefitsItemProps = {
  imageUrl?: string;
  title: string;
  subtitle: string;
};

function BenefitsItem({imageUrl, title, subtitle}: BenefitsItemProps) {
  const styles = useStyles();
  return (
    <ListItem>
      {imageUrl ? <Avatar source={{uri: imageUrl}} /> : null}
      <ListItem.Content>
        <ListItem.Title style={styles.title}>{title}</ListItem.Title>
        <ListItem.Subtitle style={styles.subtitle}>
          {subtitle}
        </ListItem.Subtitle>
      </ListItem.Content>
    </ListItem>
  );
}

export default function BenefitsList({
  headline2,
  benefits,
}: RewardsInformationResponse) {
  const styles = useStyles();
  return (
    <>
      <Text style={styles.headline}>{headline2}</Text>
      <>
        {benefits.map(({headline, copy, icon}, i) => (
          <BenefitsItem
            key={i}
            imageUrl={icon?.thumbnails?.small?.url}
            title={headline}
            subtitle={copy}
          />
        ))}
      </>
    </>
  );
}

const useStyles = makeStyles(theme => {
  return {
    headline: {
      marginVertical: 20,
      fontWeight: '600',
    },
    title: {
      fontWeight: '600',
    },
    subtitle: {
      color: theme.colors.grey2,
    },
  };
});
